export function sendAnalyticsEventAsync(evtType, evtParameters) {
  if (typeof gtag === 'function') {
    gtag('event', evtType, evtParameters);
  }
}
